import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';

export interface UserSubscription {
  firstName: string;
  lastName: string;
  id: number;
  email: string;
  /**
   * The user's CoreAI identity scope, as stamped on the chats they fire. Match it against
   * an invocation's scopes to attribute it, instead of parsing the scope format here.
   */
  coreAIScope: string | null;
}

export default function useGetUsers<TData = Response<UserSubscription[]>>(
  enabled = true,
  select?: (data: Response<UserSubscription[]>) => TData,
) {
  const request: Request = {
    url: ENDPOINTS.subscription.users.main,
    config: {
      method: 'get',
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.subscription.users.main],
    queryFn: () => client(request),
    enabled,
    staleTime: 180 * 60 * 1000,
    select,
  };

  const { data, ...rest } = useQuery<
    Response<UserSubscription[]>,
    CronoError,
    TData
  >(requestConfig);

  return { data, ...rest };
}
